import React from "react";

// Catálogo de premios activos (el de `useFirestore.getAwards`) para que las
// tarjetas del listado de usuarios muestren los premios asignados a cada
// jurado por nombre. Lo carga una sola vez la página de Usuarios: pedirlo en
// cada tarjeta repetiría la misma query por usuario.
export const UserAwardsContext = React.createContext([]);
